<template>
  <div class="container ">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-12">
        <!-- Material form login -->
        <div class="card">

          <h5 class="card-header info-color white-text text-center py-4">
            <strong>Login</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5 pt-3">
            <p v-if="error" class="color-danger">
                {{error}}
            </p>
            <!-- Form -->
            <form class="text-center" style="color: #757575;"  @submit.prevent="login">
              <mdb-input type="text" required label="E-Mail" v-model="username" />
              <mdb-input type="password" required :label="$t('Global.Passwort')" v-model="password" />
              

              <div class="d-flex justify-content-around">
                <div>
                  <!-- Forgot password -->
                  <router-link :to="{ name: 'resetPassword'}">{{$t('Global.Passwortvergessen')}}</router-link>

                </div>
              </div>





              <!-- Sign in button -->
              <mdb-btn color="primary" type="submit" class="my-4">Login</mdb-btn>
              
      
              <div class="d-flex flex-column mb-3">
                <router-link :to="{ name: 'registerSuchend'}" class="text-center">{{$t('Global.RegisterSuchender')}}</router-link>
                <router-link :to="{ name: 'registerVermieter'}">{{$t('Global.RegisterVermieter')}}</router-link>
              </div>

              <div class="d-flex justify-content-around">
                <div>
                  <a href="mailto:wohnungsdatenbank.io@zv.uni-freiburg.de">{{$t('Global.ContactMail')}}</a>

                </div>
              </div>

            </form>
            <!-- Form -->

          </div>

        </div>
        <!-- Material form login -->
      </div>
    </div>
  </div>

</template>

<script>
import mapActions from 'vuex'
import userService from "@/services/AngebotService.js";
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect } from 'mdbvue';
export default {
  name: "Login",
  components: {
    userService,
    mdbInput,
    mdbBtn
  },
  data () {
    return {
      username: '',
      password: '',
      errorM: {},
      //error: "",
      errorMessages: {
        messageOne: "Keine Email adresse eingegeben.",
        messageTwo: "Email/Passwort nicht eingegeben.",
        messageThree: "Kein Passwort eingegeben.",
      }
    }
  },
  methods: {
    login() {
      let username = this.username;
      let password = this.password;

      // Abfrage ob username und passwort gesetzt sind, falls nicht wird eine Error Nachricht angezeigt
      if (username && password) {

        // Falls beides gesetzt ist, wird der versuch des Loggins mit diesen Daten versucht
        this.$store.dispatch("login", {username: this.username, password: this.password}).then(response => {

         // this.error = this.$store.getters.error
        })
      }
    }

  },
  computed: {
    error () {
      return this.$store.getters.error
    }
  }
};
</script>

<style scoped>
a{
    color: #2c3e50;
  }
</style>
